import { h, svgUse } from '../../utils/dom.js';

export function SectionTitle({ icon, title }) {
  return h('div', { class: 'section-title' },
    icon ? h('div', { class: 'icon-chip' }, svgUse(icon)) : null,
    h('h2', {}, title),
  );
}